import { Col, DatePicker, Row, Tabs, message, Radio } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Card, Form, Input } from "antd";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Select } from "antd";
import { addVideo, fetchOneVideo, updateVideo } from "redux/features/gallery";
import { MyEditor } from "../../../components/Editor";
import VideoUploader from "components/shared-components/VideoUploader";
import VideoPreview from "components/shared-components/VideoPreview";
import moment from "moment";

const selectStyle = {
  width: "100%",
  backgroundColor: "white",
};

const rules = [
  {
    required: true,
    message: "Wajib Diisi!",
  },
];

export const ADD_VIDEO = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const location = useLocation();

  const [idBody, setIdBody] = useState("");
  const [enBody, setEnBody] = useState("");
  const [subcategories, setSubcategories] = useState();
  const [tags, setTags] = useState();
  const [imgUrl, setImgUrl] = useState("");

  const [imgUrlDisplay, setImgUrlDisplay] = useState("");
  const [uploadMethod, setUploadMethod] = useState("upload");

  //   const getYoutubeThumbnail = (url) => {
  //     try {
  //       const videoId = url.split("v=")[1]?.split("&")[0] || url.split("/").pop();
  //       return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  //     } catch (error) {
  //       console.error("Invalid YouTube URL:", url);
  //       return null;
  //     }
  //   };

  const onFinish = (values) => {
    if (uploadMethod === "upload") {
      values.url = imgUrl;
    } else if (uploadMethod === "url") {
      values.url = imgUrlDisplay;
    }

    values.type = "video";

    console.log("values :", values);
    if (location?.state?.id) {
      updateData(values);
    } else {
      createData(values);
    }
  };

  const createData = async (values) => {
    console.log("create data :", values);
    try {
      await dispatch(
        addVideo({
          ...values,
          photo: imgUrl ? imgUrl : undefined,
        })
      ).unwrap();
      history.push("/app/video");
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const updateData = async (values) => {
    try {
      await dispatch(
        updateVideo({
          ...values,
          url: imgUrl ? imgUrl : undefined,
          id: location?.state?.id,
        })
      ).unwrap();
      history.push("/app/video");
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getDataById = async (id) => {
    try {
      const data = await dispatch(fetchOneVideo(id)).unwrap();
      form.setFieldsValue({
        ...data.data,
        date: data.data.date ? moment(data.data.date) : null,
      });
      setImgUrlDisplay(data.data.url);
    } catch (err) {
      console.log(err);
    }
  };

  const handleImageUpload = (info) => {
    if (info.file.status === "uploading") {
      // setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      const { secure_url } = info.file.response.data;
      setImgUrl(secure_url);
      setImgUrlDisplay(secure_url);
    }
  };

  useEffect(() => {
    console.log(location?.state?.id);
    if (location?.state?.id) {
      getDataById(location?.state?.id);
    }
  }, []);

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Tambah/Update Video</h2>
          <p>Isi data Video.</p>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={18} sm={18} md={18} lg={18} gap={3}>
          <Card>
            <Form
              name="basic"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item label="Nama Video" name="name">
                <Input />
              </Form.Item>

              <Form.Item label="Tanggal" name="date">
                <DatePicker showTime format="YYYY-MM-DD" />
              </Form.Item>
              <VideoPreview src={imgUrlDisplay} />

              <Form.Item label="Input Video">
                <Radio.Group
                  onChange={(e) => setUploadMethod(e.target.value)}
                  value={uploadMethod}
                >
                  <Radio value="upload">Upload Video</Radio>
                  <Radio value="url">Masukkan URL Video</Radio>
                </Radio.Group>
              </Form.Item>
              {uploadMethod === "upload" && (
                <>
                  <Form.Item label="Upload Video" name="videoUpload">
                    <VideoUploader
                      imageUrl={imgUrl}
                      onChange={handleImageUpload}
                    />
                  </Form.Item>
                </>
              )}

              {uploadMethod === "url" && (
                <Form.Item label="Video URL" name="url">
                  <Input
                    placeholder="https://example.com/video.mp4"
                    onChange={(e) => setImgUrlDisplay(e.target.value)}
                  />
                </Form.Item>
              )}

              {/* <Form.Item>
                <MyEditor
                  data={idBody}
                  setState={setIdBody}
                  defaultValue="Deskripsi"
                />
              </Form.Item> */}

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
        {/* <Col xs={6} sm={6} md={6} lg={6} gap={3}>
          <Card>
            <video
              src={imgUrlDisplay}
              style={{ width: "100%", maxHeight: 200 }}
            ></video>
            <br></br>
            <h3>Ubah Video</h3>
            <Form.Item label="Video" name="photo">
              <VideoUploader imageUrl={imgUrl} onChange={handleImageUpload} />
            </Form.Item>
          </Card>
        </Col> */}
      </Row>
    </>
  );
};

export default ADD_VIDEO;
